/**
 * Altersgruppen-Farben Utility
 * 
 * Diese Datei definiert einheitliche Farben für alle Altersgruppen
 * und kann in verschiedenen Komponenten verwendet werden.
 */

export const AGE_GROUP_COLORS = {
  'Kinder': {
    name: 'age-kinder',
    bg: 'bg-emerald-500',
    bgLight: 'bg-emerald-100',
    text: 'text-emerald-700',
    border: 'border-emerald-200',
    hex: '#10b981'
  },
  'Jugend': {
    name: 'age-jugend',
    bg: 'bg-blue-500',
    bgLight: 'bg-blue-100',
    text: 'text-blue-700',
    border: 'border-blue-200',
    hex: '#3b82f6'
  },
  'Erwachsene': {
    name: 'age-erwachsene',
    bg: 'bg-violet-500',
    bgLight: 'bg-violet-100',
    text: 'text-violet-700',
    border: 'border-violet-200',
    hex: '#8b5cf6'
  },
  'Senioren': {
    name: 'age-senioren',
    bg: 'bg-amber-500',
    bgLight: 'bg-amber-100',
    text: 'text-amber-700',
    border: 'border-amber-200',
    hex: '#f59e0b'
  },
  'Senioren Plus': {
    name: 'age-senioren-plus',
    bg: 'bg-red-500',
    bgLight: 'bg-red-100',
    text: 'text-red-700',
    border: 'border-red-200',
    hex: '#ef4444'
  }
};

/**
 * Gibt die Farben für eine Altersgruppe zurück
 * @param {string} ageGroup - Name der Altersgruppe
 * @returns {object} Farb-Objekt mit Tailwind-Klassen
 */
export const getAgeGroupColors = (ageGroup) => {
  return AGE_GROUP_COLORS[ageGroup] || {
    name: 'gray',
    bg: 'bg-gray-500',
    bgLight: 'bg-gray-100',
    text: 'text-gray-800',
    border: 'border-gray-200',
    hex: '#6b7280'
  };
};

/**
 * Gibt die Tailwind-Klassen für ein Altersgruppen-Badge zurück
 * @param {string} ageGroup - Name der Altersgruppe
 * @param {boolean} selected - Ob das Badge ausgewählt ist
 * @returns {string} Tailwind-Klassen String
 */
export const getAgeGroupBadgeClasses = (ageGroup, selected = false) => {
  const colors = getAgeGroupColors(ageGroup);
  
  if (selected) {
    return `${colors.bg} text-white shadow-lg transform scale-105`;
  }
  
  return `${colors.bgLight} ${colors.text} border ${colors.border} hover:${colors.bg} hover:text-white hover:shadow-md`;
};

/**
 * Sortiert Altersgruppen in der gewünschten Reihenfolge
 * @param {Array} ageGroups - Array von Altersgruppen
 * @returns {Array} Sortiertes Array
 */
export const sortAgeGroups = (ageGroups) => {
  const order = ['Kinder', 'Jugend', 'Erwachsene', 'Senioren', 'Senioren Plus'];
  return ageGroups.sort((a, b) => {
    const indexA = order.indexOf(a);
    const indexB = order.indexOf(b);
    return indexA - indexB;
  });
};

/**
 * Gibt alle verfügbaren Altersgruppen in der richtigen Reihenfolge zurück
 * @returns {Array} Array aller Altersgruppen
 */
export const getAllAgeGroups = () => {
  return ['Kinder', 'Jugend', 'Erwachsene', 'Senioren', 'Senioren Plus'];
};
